import * as type from "../types";
import moment from "moment";

const initialState = {
  info: {},
  filterPeriod: moment().format("YYYYMM"),
  invoiceFilterPeriod: moment().subtract(1, "month").format("YYYYMM"),
  reconciliationList: [],
  subTotalsInPage: {},
  subTotalsInSystem: {},
  selectedReconciliation: {
    selectedId: null,
    details: [],
    loadingDetails: false,
    errorDetails: false,
    itemDetails: [],
    loadingItemDetails: false,
    errorItemDetails: false,
    totalAmount: 0,
    totalPrice: 0,
  },
  loading: false,
  error: false,
};

const reconciliation = (state = initialState, action) => {
  switch (action.type) {
    case type.SET_FILTER_PERIOD:
      return {
        ...state,
        filterPeriod: action.payload,
      };
    case type.SET_INVOICE_FILTER_PERIOD:
      return {
        ...state,
        invoiceFilterPeriod: action.payload,
      };
    case type.GET_RECONCILIATION_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_RECONCILIATION_INFO_SUCCEEDED:
      return {
        ...state,
        info: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_RECONCILIATION_INFO_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case type.GET_RECONCILIATION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_RECONCILIATION_LIST_SUCCEEDED:
      return {
        ...state,
        reconciliationList: action.payload.reconciliationList,
        subTotalsInPage: action.payload.subTotalsInPage,
        subTotalsInSystem: action.payload.subTotalsInSystem,
        loading: false,
        error: false,
        total: {
          totalElement: action.payload.totalElement,
          totalPage: action.payload.totalPage,
        },
        dueDate: action.payload.dueDate,
        invoiceDate: action.payload.invoiceDate,
      };
    case type.GET_RECONCILIATION_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case type.SET_SELECTED_RECONCILIATION_ID:
      return {
        ...state,
        selectedReconciliation: {
          ...state.selectedReconciliation,
          selectedId: action.payload,
          itemDetails: [],
        },
      };
    case type.GET_SELECTED_RECONCILIATION_DETAILS_REQUEST:
      return {
        ...state,
        selectedReconciliation: {
          ...state.selectedReconciliation,
          loadingDetails: true,
          errorDetails: false,
        },
      };
    case type.GET_SELECTED_RECONCILIATION_DETAILS_SUCCEEDED:
      return {
        ...state,
        selectedReconciliation: {
          ...state.selectedReconciliation,
          details: action.payload?.details,
          subTotalsInPage: action.payload.subTotals,
          loadingDetails: false,
          errorDetails: false,
        },
      };
    case type.GET_SELECTED_RECONCILIATION_DETAILS_FAILED:
      return {
        ...state,
        selectedReconciliation: {
          ...state.selectedReconciliation,
          loadingDetails: false,
          errorDetails: true,
        },
      };
    case type.GET_SELECTED_RECONCILIATION_ITEM_DETAILS_REQUEST:
      return {
        ...state,
        selectedReconciliation: {
          ...state.selectedReconciliation,
          loadingItemDetails: true,
          errorItemDetails: false,
        },
      };
    case type.GET_SELECTED_RECONCILIATION_ITEM_DETAILS_SUCCEEDED:
      return {
        ...state,
        selectedReconciliation: {
          ...state.selectedReconciliation,
          itemDetails: [
            ...state.selectedReconciliation.itemDetails,
            ...action.payload.reconciliationDto,
          ],
          totalAmount: action.payload.totalAmount,
          totalPrice: action.payload.totalPrice,
          loadingItemDetails: false,
          errorItemDetails: false,
        },
      };
    case type.GET_SELECTED_RECONCILIATION_ITEM_DETAILS_FAILED:
      return {
        ...state,
        selectedReconciliation: {
          ...state.selectedReconciliation,
          loadingItemDetails: false,
          errorItemDetails: true,
        },
      };
    case type.REMOVE_RECONCILIATION_ITEM_DETAILS:
      if (action.payload === "PIU") {
        const firsFilter = state.selectedReconciliation.itemDetails.filter(
          (item) => item.type !== action.payload
        );
        const updatedItemDetails = firsFilter.filter(
          (item) => item.type !== "PIU_KATILIM"
        );
        return {
          ...state,
          selectedReconciliation: {
            ...state.selectedReconciliation,
            itemDetails: updatedItemDetails,
          },
        };
      } else {
        const updatedItemDetails =
          state.selectedReconciliation.itemDetails.filter(
            (item) => item.type !== action.payload
          );
        return {
          ...state,
          selectedReconciliation: {
            ...state.selectedReconciliation,
            itemDetails: updatedItemDetails,
          },
        };
      }

    case type.CLEAR_SELECTED_RECONCILIATION:
      return {
        ...state,
        selectedReconciliation: {
          ...state.selectedReconciliation,
          selectedId: null,
          details: [],
          itemDetails: [],
        },
      };
    case type.CLEAR_ITEM_DETAILS:
      return {
        ...state,
        selectedReconciliation: {
          ...state.selectedReconciliation,
          itemDetails: [],
        },
      };
    case type.CLEAR_INFO:
      return {
        ...state,
        info: {},
      };
    default:
      return state;
  }
};

export default reconciliation;
